import React, {Component} from 'react';
import styles from '../Resources/Resources.module.css';

const FilterList = (props) => {

    let filterClassName;
    if (props.state === true){
        filterClassName = 'filterListHeaderOpen';
    } else {
        filterClassName = 'filterType';
    }

    return(
        <div className={filterClassName}>
            <h1
                onClick={props.handleClick}
                id={props.name}
                className={
                    props.style.length !== 0 ?
                        styles.blue :
                        styles.grey
                }

            ><span onClick={props.handleClick}>{props.name}</span> <span onClick={props.handleClick} className={styles.filterSign}></span>{props.state === true ? '-' : '+'}</h1>
            <ul className={styles.resourcesFilterList}>
                {props.data.map( elem => (
                    <li className={`${styles.filterListElement} fontBrown`} key={elem.id}>
                        <label htmlFor={elem.id}>
                            <input
                                id={elem.id}
                                className='filterCheckbox'
                                vocabulary={elem.vocabulary}
                                name={elem.id}
                                type="checkbox"
                                onChange={props.onChange}
                            />
                            { elem.title }
                        </label>
                    </li>
                ))}
            </ul>
        </div>
    )
}

class Filters extends Component {
    render() {
        return (
                <FilterList
                    handleClick={this.props.handleClick}
                    data={this.props.data}
                    name={this.props.name}
                    onChange={this.props.updateArticles}
                    state={this.props.state}
                    style={this.props.style}
                />
        );
    }
}

export default Filters;



// WEBPACK FOOTER //
// ./src/components/Resources/Filters.js